(function () {
const { VProv, VMaturity } = window;
function glanceFacts(report) {
  const p = report.proposed_profile;
  if (!p) return [];
  const regs = p.region_policies || [];
  const ship = regs.filter((r) => r.disposition === 'ship');
  const img = ship.filter((r) => r.implementation_mode === 'image');
  const live = ship.filter((r) => r.implementation_mode === 'live');
  const omit = regs.filter((r) => r.disposition === 'omit');
  const meta = regs.filter((r) => r.disposition === 'metadata');
  const esp = regs.filter((r) => r.disposition === 'inject');
  const nice = (s) => String(s).replace(/^design_chrome\.?/, 'design chrome ').replace(/_/g, ' ').trim();
  const rule = (prop) => (p.layout_rules || []).filter((x) => x.property === prop);
  const fonts = rule('font_size').map((x) => nice(x.semantic_role) + ' ' + x.typed_value.value + 'px');
  const mobile = [...new Set(ship.map((r) => r.responsive_behavior))];
  const auth = {};
  regs.forEach((r) => { auth[r.authority_selected] = (auth[r.authority_selected] || 0) + 1; });
  const top = Object.entries(auth).sort((a, b) => b[1] - a[1]);
  const out = [];
  out.push({ k: 'Layout', t: ship.length + ' shipping regions at ' + p.container_width + 'px — ' + img.length + ' image, ' + live.length + ' live text' });
  out.push({ k: 'Order', t: ship.map((r) => nice(r.semantic_role)).join(' → ') });
  if (fonts.length) out.push({ k: 'Type', t: fonts.join(' · ') });
  if (mobile.length) out.push({ k: 'Mobile', t: mobile.join(', ') });
  if (omit.length) out.push({ k: 'Dropped', t: omit.map((r) => nice(r.semantic_role)).join(', ') + ' — omitted on purpose' });
  if (meta.length) out.push({ k: 'Metadata', t: meta.map((r) => nice(r.semantic_role)).join(', ') + ' — not rendered in the body' });
  if (esp.length || (p.wrapper_ownership || []).length) out.push({ k: 'ESP', t: (p.wrapper_ownership || []).map((x) => x.split(':').pop()).join(', ') + ' injected by ' + (p.scope && p.scope.esp_id || 'the ESP').toUpperCase() + ' at send' });
  if (top.length) out.push({ k: 'Source', t: top.map(([a, n]) => n + ' from ' + a.replace(/_/g, ' ')).join(', ') });
  const risky = img.filter((r) => /terms|cta|offer|price|legal/.test(r.semantic_role));
  if (risky.length) out.push({ k: 'Check', warn: true, t: risky.map((r) => nice(r.semantic_role)).join(' and ') + ' are image-only — confirm no essential text lives only in pixels' });
  return out;
}

function AtAGlance({ report, approved }) {
  const facts = glanceFacts(report);
  if (!facts.length) return null;
  return (
    <div className="v-glance">
      <div className="v-glance-h">
        <I.layers size={13} />
        <b>At a glance</b>
        <span>from the {approved ? 'approved' : 'proposed'} profile</span>
      </div>
      <ul className="v-glance-l">
        {facts.map((f) =>
          <li key={f.k} className={f.warn ? 'warn' : ''}>
            <span className="v-glance-k">{f.k}</span>
            <span className="v-glance-t">{f.t}</span>
          </li>)}
      </ul>
    </div>);
}

function VariantReport({ report, status }) {
  const approved = status === 'ready';
  const rejected = status === 'rejected';
  return (
    <div className="v-report" data-variant-report="">
      <AtAGlance report={report} approved={approved} />
      {report.proposed_profile && window.VariantProfileV1 &&
        <div className="v-prop">
          <div className="v-prop-h">
            <I.layers size={13} />
            <b>{approved ? 'Approved profile' : rejected ? 'Rejected profile' : 'Proposed profile'}</b>
            {!approved && <span>{rejected ? 'Not available to builds.' : 'This is the layout the harvest read out of your reference emails. Nothing is recorded until you finalize below.'}</span>}
          </div>
          <window.VariantProfileV1 p={report.proposed_profile} proposed={!approved && !rejected} />
        </div>}
      <div className="v-rep-sec">
        <div className="v-rep-h">Structure patterns <span className="muted">{report.patterns.length}</span></div>
        {!report.patterns.length && <div className="v-empty-line">No structure patterns returned.</div>}
        {report.patterns.map((p, i) => (
          <div className="v-rep-row" key={i}>
            <span className="v-rep-name">{p.name}</span>
            <span className="v-rep-detail">{p.detail}</span>
            <span className={'v-conf c-' + p.confidence}>{p.confidence}</span>
          </div>
        ))}
      </div>
      <div className="v-rep-sec">
        <div className="v-rep-h">ESP tags found <span className="muted">{report.esp_tags.length}</span></div>
        {!report.esp_tags.length && <div className="v-empty-line">No ESP tags returned.</div>}
        {report.esp_tags.map((t, i) => (
          <div className="v-rep-row" key={i}>
            <span className="v-rep-name mono">{t.tag}</span>
            <span className="v-rep-detail">{t.platform}</span>
            <span className="v-rep-count">×{t.count}</span>
          </div>
        ))}
      </div>
      <div className="v-rep-sec">
        <div className="v-rep-h">Gold candidates <span className="muted">{report.gold_candidates.length}</span></div>
        {report.gold_candidates.map((g, i) => (
          <div className="v-rep-row" key={i}>
            <span className="v-rep-name mono">{g.file}</span>
            <VProv p={g.provenance} />
            <VMaturity at={g.last_revised_at} p={g.provenance} />
          </div>
        ))}
      </div>
    </div>
  );
}


window.VariantReport = VariantReport;
})();
